import { isDevModEnabled } from "../runtimeFlags";

// Cache NOOM_ENV to avoid repeated require() calls
let cachedNoomEnv: string | null = null;

function getNoomEnv() {
  if (!cachedNoomEnv) {
    // Lazy import to avoid circular dependencies
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    cachedNoomEnv = require("src/config").appConfig.NOOM_ENV;
  }
  return cachedNoomEnv;
}

/**
 * Provides a common logging layer for console logs.
 *
 * Utilizing these methods over direct console log calls allows for
 * centralized logging and easy toggling of logging in tests, etc.
 */
export function logInfo(...args: any[]) {
  if (getNoomEnv() !== "production" || isDevModEnabled()) {
    // eslint-disable-next-line no-console
    console.info(...args);
  }
}

export function logDebug(...args: any[]) {
  // Push to debug in development for visibility, info in production
  // for monitoring tools to pickup.
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.debug(...args);
  } else {
    logInfo(...args);
  }
}
